if (!customElements.get('product-gallery-slider')) {
  customElements.define(
    'product-gallery-slider',
    class ProductGallerySlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.slides = [...this.querySelectorAll('[data-media-item]')];
        this.dots = [...this.querySelectorAll('[data-slider-dot]')];

        this.onVideoPlaying = (event) => event.target.classList.add('is-playing');
        this.videos = [...this.querySelectorAll('video')];
        this.videos.forEach((video) => video.addEventListener('playing', this.onVideoPlaying, { once: true }));

        if (!this.track || this.slides.length < 2) return;

        this.warmGallery = this.warmGallery.bind(this);
        this.warmObserver = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            this.warmObserver.disconnect();
            if (document.readyState === 'complete') {
              this.scheduleWarm();
            } else {
              window.addEventListener('load', this.warmGallery, { once: true });
            }
          },
          { rootMargin: '100% 0px' }
        );
        this.warmObserver.observe(this);

        this.activeIndex = 0;
        this.onScroll = this.onScroll.bind(this);
        this.onDotClick = this.onDotClick.bind(this);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
      }

      scheduleWarm() {
        if ('requestIdleCallback' in window) {
          this.idleHandle = window.requestIdleCallback(() => this.loadHidden(), { timeout: 3000 });
        } else {
          this.idleHandle = window.setTimeout(() => this.loadHidden(), 1500);
        }
      }

      warmGallery() {
        this.scheduleWarm();
      }

      loadHidden() {
        if (navigator.connection?.saveData) return;
        this.slides.forEach((slide) => {
          slide.querySelectorAll('img[loading="lazy"]').forEach((image) => {
            image.loading = 'eager';
          });
        });
      }

      disconnectedCallback() {
        this.videos?.forEach((video) => video.removeEventListener('playing', this.onVideoPlaying));
        this.warmObserver?.disconnect();
        window.removeEventListener('load', this.warmGallery);
        if (this.idleHandle) {
          if ('cancelIdleCallback' in window) window.cancelIdleCallback(this.idleHandle);
          window.clearTimeout(this.idleHandle);
        }
        this.track?.removeEventListener('scroll', this.onScroll);
        this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const step = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
          if (step <= 0) return;
          const index = Math.round(this.track.scrollLeft / step);
          this.setActive(Math.min(Math.max(index, 0), this.slides.length - 1));
        });
      }

      onDotClick(event) {
        const index = Number(event.currentTarget.dataset.sliderDot) || 0;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const slide = this.slides[index];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      setActive(index) {
        if (index === this.activeIndex) return;
        this.activeIndex = index;
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
        const buyBox = this.closest('product-buy');
        if (buyBox && typeof buyBox.showMedia === 'function') {
          buyBox.showMedia(this.slides[index].dataset.mediaItem);
        }
      }
    }
  );
}
